(ns common.schema.entities.check-list
  (:require
   [common.schema.schema-utils :as su]))

(def schema
  (concat (su/text-simple-field :check-list/label
                                "Label"
                                {:authorization            su/access-user-user
                                 :not-clearable?           true
                                 :mandatory-config         :mandatory/always
                                 :system-required?         true
                                 :system-semantics
                                 su/user-provided-system-required-field-semantics
                                 :constraints              {:constraint/string-min-length 1
                                                            :constraint/string-max-length 100}
                                 :default-field-visibility :in-use-disabled})
          (su/text-edn-field :check-list/configuration
                             "configuration"
                             {:authorization            su/access-user-user
                              :default-field-visibility :in-use-disabled})
          (su/keyword-field :check-list/target-entity-type
                            "Entity type"
                            nil
                            {:authorization            su/access-user-user
                             :default-field-visibility :in-use-disabled
                             :editor-type              :editor.type/none
                             :grid-type                :editor.type/none})))
